import { ChildrenOf } from "@/Helpers/CenterOptions.types";
import { useResponsive, useT, useApp } from "@/Hooks";
import CenterSiteTemplatePageCreateOrEditPage, {
  CenterSiteTemplatePageCreateOrEditPageForm,
  CenterSiteTemplatePageCreateOrEditPageProps,
} from "./CreateOrEdit/CenterSiteTemplatePageCreateOrEditPage";
import CenterSiteTemplatePageImportPage, { CenterSiteTemplatePageImportPageProps } from "./Import/CenterSiteTemplatePageImportPage";

function useCenterSiteTemplatePageModal() {
  const { modal } = useApp();
  const { isMobile } = useResponsive();
  const t = useT();
  const showCreateOrEdit = (
    props: Omit<CenterSiteTemplatePageCreateOrEditPageProps, "callback">,
  ) => {
    return new Promise<boolean>((resolve) => {
      const m = modal.info({
        icon: null,
        title: props.values?.Id
          ? t("common.action.edit", undefined, "Edit")
          : t("common.action.create", undefined, "Create"),
        footer: [],
        closable: true,
        centered: true,
        width: isMobile ? "100vw" : "70vw",
        content: (
          <CenterSiteTemplatePageCreateOrEditPage
            {...props}
            callback={(result) => {
              m.destroy();
              resolve(result);
            }}
          />
        ),
      });
    });
  };
  return {
    showCreate: async (
      usageType: ChildrenOf<"CenterSiteTemplateUsageType">,
      values?: Partial<CenterSiteTemplatePageCreateOrEditPageForm>,
    ) => showCreateOrEdit({ usageType, values }),
    showEdit: async (usageType: ChildrenOf<"CenterSiteTemplateUsageType">, id: number) =>
      showCreateOrEdit({ usageType, values: { Id: id } }),
    showImport: (options?: Omit<CenterSiteTemplatePageImportPageProps, "callback">) =>
      new Promise<boolean>((resolve) => {
        const m = modal.info({
          icon: null,
          title: t("common.action.import", undefined, "Import"),
          footer: [],
          closable: true,
          centered: true,
          width: isMobile ? "100vw" : "80vw",
          content: (
            <CenterSiteTemplatePageImportPage
              centerId={options?.centerId}
              callback={(result) => {
                m.destroy();
                resolve(result);
              }}
            />
          ),
        });
      }),
  };
}
export default useCenterSiteTemplatePageModal;
